module.exports = __webpack_public_path__ + "img/25.576ec41f.jpg";